import { render, staticRenderFns } from "./dg-banner.vue?vue&type=template&id=d3972258&scoped=true"
import script from "./dg-banner.vue?vue&type=script&lang=js"
export * from "./dg-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3972258",
  null
  
)

export default component.exports